import { Component, Vue, Prop } from "vue-property-decorator";
import { ProductTypeServiceProxy } from '@/service-proxies/app-v2/product.service-proxies'
import { ProductionPlanTypeProductTypeServiceProxy, ProductionPlanTypeProductTypeDTO } from '@/service-proxies/app-v2/coproduction.service-proxies'
const productTypeService = new ProductTypeServiceProxy()
const productionPlan = new ProductionPlanTypeProductTypeServiceProxy()
@Component
export default class PlanSetting extends Vue {
  @Prop() typeId: string
  visible = false
  typeList = []
  checkedList = []
  confirmLoading = false
  handleOk(){
    if(this.checkedList.length == 0) {
      this.$message.warning(this.$t('page_plan_must_check'))
      return
    }
    this.confirmLoading = true
    const data = new ProductionPlanTypeProductTypeDTO({
      planTypeId: this.typeId,
      productTypeIds: this.checkedList
    })
    productionPlan.saveProductionTypeProductType(data).then(
      res =>{        
        this.checkedList = []
        this.confirmLoading = false
        this.visible = false
        this.$emit('cancel')
      }
    ).catch(() => {
      this.confirmLoading = false
    })
  }
  handleCancel(){
    this.checkedList = []
    this.visible = false
  }
  onChange(e){
    console.log(e)
    this.checkedList = e
  }
  openModal(){
    productTypeService.getPageProductTypes(1,'','',999,2).then(res =>{
      this.typeList = res.records
      productionPlan.getProductTypeIds(this.typeId).then(
        res=> {
          this.checkedList = res
          this.visible = true
        }
      )
    })
  }
  render() {
    return (
      <a-modal
        title={this.$t('page_plan_complete_settype')}
        visible={this.visible}
        confirmLoading={this.confirmLoading}
        onOk={() => this.handleOk()}
        onCancel={() => this.handleCancel()}
        maskClosable={false}
      >
        <a-checkbox-group style="width:100%;" value={this.checkedList} onChange={e => this.onChange(e)}>
          <a-row>
            {
              this.typeList.map(item => {
                return <a-col span={8}><a-checkbox value={item.id}>{item.name}</a-checkbox></a-col>
              })
            }
            
          </a-row>
        </a-checkbox-group>
      </a-modal>
    )
  }
}